export const routes = [
    {
        path: '/admin-sign',
        name: "Login",
        component: () =>
            import ('../views/Auth.vue'),
    },
    {
        path: "/clients_payment",
        component: () =>
            import ("../views/ClientPayment.vue"),
        name: "GuestPage",
    },
    {
        path: "/company/:id",
        component: () =>
            import ("../views/CompanyDetail.vue"),
        name: "Registration",
    },

    {
        path: "/admin-login",
        component: () =>
            import ("../views/Auth.vue")
    },

    {
        path: "/kassa-login",
        component: () =>
            import ("../views/KassaLogin.vue")
    },


    {
        path: "/",
        component: () =>
            import ("../views/LandingPage.vue"),
        name: "LandingPage",
    },
    {
        path: "/blog",
        component: () =>
            import ("../views/BlogPage.vue"),
        name: "BlogPage",
    },
    {
        path: "/blog/:slug",
        component: () =>
            import ("../views/BlogPost.vue"),
        name: "BlogPost",
    },
    {
        path: "/register",
        component: () =>
            import ("../views/RegisterPage.vue"),
        name: "RegisterPage",
    },
    {
        path: "/auth/callback",
        component: () =>
            import ("../views/AuthCallback.vue"),
        name: "AuthCallback",
    },
    {
        path: "/auth/complete",
        component: () =>
            import ("../views/AuthComplete.vue"),
        name: "AuthComplete",
    },
    {
        path: "/super-admin",
        component: () =>
            import ("../views/PlatformAdmin.vue"),
        name: "PlatformAdmin",
    },
    {
        path: "/super-admin-login",
        component: () =>
            import ("../views/PlatformAdminLogin.vue"),
        name: "PlatformAdminLogin",
    },
    {
        path: "/company_add",
        component: () =>
            import ("../views/Registration.vue"),
        name: "Registration",
    },
    {
        path: "/bonuses",
        component: () =>
            import ("../views/Bonuses.vue"),
        name: "Bonuses",
    },
    {
        path: "/profile",
        component: () =>
            import ("../views/Profile.vue"),
        name: "Registration",
    },
    {
        path: "/guest/:id",
        component: () =>
            import ("../views/Guest.vue"),
        name: "Guest",
    },
    {
        path: "/cash",
        component: () =>
            import ("../views/CashInterface.vue"),
        name: "CashInterface",
    },


    {
        path: '/admin_panel',
        component: () =>
            import ('../views/AdminControl.vue'),
        children: [
            {
                path: "",
                component: () =>
                    import ("../views/ProductControl.vue"),
                name: "ProductControl",
            },
            {
                path: "/barcodes",
                component: () =>
                    import ("../views/BarcodeGenerator.vue"),
                name: "BarcodeGenerator",
            },
            {
                path: "/price-tags",
                component: () =>
                    import ("../views/PriceTags.vue"),
                name: "PriceTags",
            },
            {
                path: "/category_control",
                component: () =>
                    import ("../views/CategoryControl.vue"),
                name: "CategoryControl",
            },
            {
                path: "/supplier_control",
                component: () =>
                    import ("../views/SupplierControl.vue"),
                name: "SupplierControl",
            },
            {
                path: "/catalog_menu",
                component: () =>
                    import ("../views/CatalogMenuPage.vue"),
                name: "CatalogMenuPage",
            },
            {
                path: "/payment_types",
                component: () =>
                    import ("../views/PaymentTypeControl.vue"),
                name: "PaymentTypeControl",
            },
            {
                path: "/sale_mode",
                component: () =>
                    import ("../views/SaleModeControl.vue"),
                name: "SaleModeControl",
            },
            {
                path: "/discounts",
                component: () =>
                    import ("../views/DiscountControl.vue"),
                name: "DiscountControl",
            },
            {
                path: "/modifiers",
                component: () =>
                    import ("../views/ModifierControl.vue"),
                name: "ModifierControl",
            },
            {
                path: "/cashiers",
                component: () =>
                    import ("../views/CashierControl.vue"),
                name: "CashierControl",
            },
            {
                path: "/stock",
                component: () =>
                    import ("../views/StockPage.vue"),
                name: "StockPage",
            },
            {
                path: "/sales",
                component: () =>
                    import ("../views/SalePage.vue"),
                name: "SalePage",
            },
            {
                path: "/analytic",
                component: () =>
                    import ("../views/Analytic.vue"),
                name: "SalePage",
            },
            {
                path: "/bonus_clients",
                component: () =>
                    import ("../views/BonusInterface.vue"),
                name: "BonusClientsControl",
            },
            {
                path: "/bonuses",
                redirect: "/bonus_clients",
            },
            {
                path: "/loans",
                component: () =>
                    import ("../views/LoanInterface.vue"),
                name: "BonusInterface",
            },
        ]
    },
    {
        path: '/main',
        component: () =>
            import ('../views/Main.vue'),
        children: [
            {
                path: "/",
                component: () =>
                    import ("../views/Profile.vue"),
                name: "Sign",
            },
            {
                path: "/settings",
                component: () =>
                    import ("../views/ProfileSettings.vue"),
                name: "Sign",
            },
            {
                path: "/result",
                component: () =>
                    import ("../views/Result.vue"),
                name: "Sign",
            },
            {
                path: "/register",
                component: () =>
                    import ("../views/UserRegistration.vue"),
                name: "Sign",
            },
        ],


    },

    {
        path: '/admin',
        component: () =>
            import ('../components/AdminPanel.vue'),

        children: [{
            path: "/",
            component: () =>
                import ("../views/Auth.vue"),
            name: "Sign",
        },

            {
                path: "/orders",
                component: () =>
                    import ("../components/Orders.vue"),
                name: "Orders",
            },
            {
                path: "/profile",
                component: () =>
                    import ("../components/Profile.vue"),
                name: "Registration",
            },


        ]
    },
    {
        path: "/mailing",
        component: () =>
            import ("../views/Mailing.vue"),
        name: "Mailing",
    },


]